import React, { useState } from 'react'
import { injectIntl } from 'gatsby-plugin-intl';
import PropTypes from "prop-types";
import styled from "styled-components";
import { device } from "../device";
import {H2, DownloadBtn} from '../styledComponents1'

import { CopyToClipboard } from 'react-copy-to-clipboard';
import { CSSTransition } from 'react-transition-group';

import './animation.css';


function TitleBlock({ intl, ...props }) {
    const downloadLink = props.downloadLink;
    const type = props.type;

    const BlockHeader = styled.div`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin: ${
            type === '2' ? '0 0 48px' : '0 0 24px'
        };
        @media ${device.sm} {
            align-items: center;
            flex-direction: row;
            margin: ${
                type === '2' ? '0 0 64px' : '0 0 32px'
            };
        }
    `;

    const TitleWrapper = styled.div`
        align-items: center;
        display: flex;
    `;

    const Title = styled(H2)`
        margin: 0;
    `;

    const SuccessMessage = styled.div`
        position: fixed;
        top: 0;
        left: 0;

        align-items: center;
        display: flex;
        justify-content: center;
        width: 100%;

        padding: 10px 0;

        font-size: 16px;
        text-align: center;

        background: var(--green1);

        z-index: 10001;
        svg {
            margin-right: 16px;
        }
        span {
            display: inline-block;
        }
    `;
    const CopyBtn = styled.button`
        align-items: center;
        display: flex;
        justify-content: center;

        height: 32px;
        width: 32px;
        flex: 0 0 32px;
        max-width: 32px;
        padding: 0;
        margin-left: 16px;
        margin-top: 3px;

        color: var(--brand);
        cursor: pointer;

        border: 1px solid var(--brand);
        border-radius: 50%;
        background: transparent;

        outline: 0;
        transition: border .15s ease-in-out; 
        @media ${device.lg} {
            margin-top: 5px;
        }
        svg {
            height: 16px;
            width: 16px;
            path {
                transition: fill .15s ease-in-out; 
            }
        }
        &:hover {
            border-color: var(--midle-gray4);
            svg {
                path {
                    fill: var(--midle-gray4);
                }
            }
        }
    `;

    const showSuccessBlock = () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1000);
    }

    const [copied, setCopied] = useState(false);

    const getCurrentPathWithoutLastPart = () => {
        if (typeof window !== 'undefined') {
            return window.location.protocol + '//' + window.location.host + window.location.pathname;
        }
    }

    const copyUrl = getCurrentPathWithoutLastPart() + "#" + props.href;
    
    if (downloadLink) {
        return (
            <>
                <BlockHeader>
                    <TitleWrapper>
                        <Title>{props.title}</Title>
                        {props.href &&
                            <CopyToClipboard onCopy={() => showSuccessBlock()} text={copyUrl}>
                                <CopyBtn>
                                    <svg aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"></path></svg>
                                </CopyBtn>
                            </CopyToClipboard>
                        }
                    </TitleWrapper>
                    <DownloadBtn href={downloadLink} />
                </BlockHeader>
                <CSSTransition
                    in={copied}
                    timeout={300}
                    classNames="alert"
                    unmountOnExit
                >
                    <SuccessMessage>
                        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fillRule="evenodd"><rect stroke="#242424" strokeWidth=".75" x=".375" y=".375" width="23.25" height="23.25" rx="11.625"/><path d="M10.366 15.92l6.557-6.812a.28.28 0 000-.386l-.618-.642a.256.256 0 00-.372 0l-5.753 5.976-2.113-2.196a.256.256 0 00-.372 0l-.618.643a.28.28 0 000 .386l2.918 3.031a.256.256 0 00.371 0z" fill="#242424" fillRule="nonzero"/></g></svg>
                        <span>{intl.formatMessage({ id: 'cipied' })}</span>
                    </SuccessMessage>
                </CSSTransition>
            </>
        )
    }
    return (
        <>
            <BlockHeader>
                <TitleWrapper>
                    <Title>{props.title}</Title>
                    {props.href &&
                        <CopyToClipboard onCopy={() => showSuccessBlock()} text={copyUrl}>
                            <CopyBtn>
                                <svg aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"></path></svg>
                            </CopyBtn>
                        </CopyToClipboard>
                    }
                </TitleWrapper>
            </BlockHeader>
            <CSSTransition
                    in={copied}
                    timeout={300}
                    classNames="alert"
                    unmountOnExit
                >
                <SuccessMessage>
                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fillRule="evenodd"><rect stroke="#242424" strokeWidth=".75" x=".375" y=".375" width="23.25" height="23.25" rx="11.625"/><path d="M10.366 15.92l6.557-6.812a.28.28 0 000-.386l-.618-.642a.256.256 0 00-.372 0l-5.753 5.976-2.113-2.196a.256.256 0 00-.372 0l-.618.643a.28.28 0 000 .386l2.918 3.031a.256.256 0 00.371 0z" fill="#242424" fillRule="nonzero"/></g></svg>
                    <span>{intl.formatMessage({ id: 'cipied' })}</span>
                </SuccessMessage>
            </CSSTransition>
        </>
    )
}

TitleBlock.propTypes = {
    type: PropTypes.string
};

export default injectIntl(TitleBlock);

